import React, { useState, useEffect } from 'react';
import { NavLink} from 'react-router-dom';
import {authEventBus, AUTH_EVENTS} from '../utils/AuthEvents';
import { FiX } from 'react-icons/fi';
import { MenuOneDropDown, MenuTwoDropDown, MenuManifesti} from '../components/modules/pannelli/MenuMobile';
import {useThemes} from '../components/hooks/hooks-mongoDB/useThemes';
import {useArticles} from '../components/hooks/hooks-mongoDB/useArticles';
import useAuth from '../components/hooks/hooks-e-commerce/useAuth'; 
import useCart from '../components/hooks/hooks-e-commerce/useCart';
import { useLoginModal } from '../contexts/LoginModalContext';
import { useAutoScrollOnVisit } from '../components/hooks/useAutoScrollOnVisit';
import LARCO from '../components/images/header/navbar/LogoBurgerNavW192SE.png'
import Carrello from '../components/images/icons/IconCarrelloBaseallRVW50.png';
import normaLoginIcon from '../components/images/icons/iconLoginW50.png'; 
import hoverLoginIcon from '../components/images/icons/iconLoginYelloW50.png'; 
import normaAccountIcon from '../components/images/icons/iconSignUpW50.png'; 
import hoverAccountIcon from '../components/images/icons/iconSignUpYelloW50.png'; 
import Lente from '../components/images/icons/SearchBlk50ft.png';
import iconLogout from '../components/images/icons/iconLogoutW50.png';
import iconPhone from '../components/images/icons/iconPhoneW48.png';
import { ProfileIcon } from '../components/svgs/EvironemtIcon';
import './navbar.scss';
import '../css/fonts/fonts.scss';

function NavBar() {
    const[ width, setWidth ] = useState(0);
    //const [hiddenSubNavBar, setHiddenSubNavBar] = useState(false);
    const [toggleNav, setToggleNav] = useState(false);
    const [toggleNavBurger, setToggleNavBurger] = useState(false);
    const [listMenu, setListMenu] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [hasCheckedAuth, setHasCheckedAuth] = useState(false);
    const [countCart, setCountCart] = useState(0);

    const [isLoginHovered, setIsLoginHovered] = useState(false);
    const [isAccountHovered, setIsAccountHovered] = useState(false);

    // reactJS hooks
    //let location = useLocation();

    // custom hooks mongoDB
    const { themes, loading: themesLoading, error } = useThemes();
    const { articles } = useArticles();

    // Custom hooks
    const { 
        user, 
        isAuthenticated, 
        getCurrentUser,
        logout, 
        loading: authLoading,
        syncExternalAuth
    } = useAuth();

    // ✅ Auto-scroll ottimizzato con easing dolce
    useAutoScrollOnVisit({
        enabled: true,
        delay: 100,
        easing: 'easeOutCubic' 
    });

    const { cart, subscribe, refreshCart } = useCart();

    const { openLoginModal } = useLoginModal(); 
    
    const handlerToggleNavBurger = (e) => {
        setToggleNavBurger(!toggleNavBurger);
    }

    const handlerCloseBurger = () => {
        setToggleNavBurger(false);
    }

    const clearSearch = () => {
        setSearchQuery('');
    };

    const handleSearch = (e) => {
        e.preventDefault();
        console.log('Searching for:', searchQuery);
        // Add your search logic here
    };

     // ✅ useEffect per sincronizzazione
    useEffect(() => {
        // Ascolta cambiamenti di autenticazione da altri componenti
        const unsubscribe = authEventBus.subscribe(
            AUTH_EVENTS.AUTH_CHANGED, 
            (data) => {
                //console.log('📢 Header riceve aggiornamento auth:', data);
                syncExternalAuth(data.user, data.isAuthenticated);
            }
        );

        // Ascolta eventi specifici
        const unsubscribeLogin = authEventBus.subscribe(
            AUTH_EVENTS.LOGIN,
            (userData) => {
                console.log('📢 Header riceve login event');
                syncExternalAuth(userData, true);
            }
        );

        const unsubscribeLogout = authEventBus.subscribe(
            AUTH_EVENTS.LOGOUT,
            () => {
                console.log('📢 Header riceve logout event');
                syncExternalAuth(null, false);
            }
        );

        const unsubscribeUpdate = authEventBus.subscribe(
            AUTH_EVENTS.USER_UPDATED,
            (userData) => {
                console.log('📢 Header riceve user update');
                syncExternalAuth(userData, true);
            }
        );

        return () => {
            unsubscribe();
            unsubscribeLogin();
            unsubscribeLogout();
            unsubscribeUpdate();
        };
    }, [syncExternalAuth]);

    // ✅ Inizializza l'auth una volta sola al mount
    useEffect(() => {
        const checkAuth = async () => {
            if (!hasCheckedAuth) {
                //console.log('🔄 Header: Verifico autenticazione utente...');
                await getCurrentUser();
                setHasCheckedAuth(true);
            }
        };
        
        checkAuth();
    }, [getCurrentUser, hasCheckedAuth]);

    // 🔥 Ascolta evento di login per refresh carrello
    useEffect(() => {
        const handleLogin = () => {
            console.log('📢 [Header] Ricevuto evento login, refresho carrello');
            refreshCart();
        };  

        const unsubscribe = authEventBus.subscribe(AUTH_EVENTS.LOGIN, handleLogin);
        
        return () => {
            unsubscribe();
        };
    }, [refreshCart]);

    // 🔥 Ascolta evento di logout per reset carrello
    useEffect(() => {
        const handleLogout = () => {
            console.log('📢 [Header] Ricevuto evento logout, refresho carrello');
            refreshCart();
            //showToast('👋 Logout effettuato con successo', 'info', 3000);
        };
        
        const unsubscribe = authEventBus.subscribe(AUTH_EVENTS.LOGOUT, handleLogout);
        
        return () => {
            unsubscribe();
        };
    }, [refreshCart]);


    // 🔥 SOTTOSCRIVITI AGLI AGGIORNAMENTI
    useEffect(() => {
        // Subscribe agli aggiornamenti del carrello
        const unsubscribe = subscribe((updatedCart) => {
            //console.log('🛒 Header: Carrello aggiornato', updatedCart);
            setCountCart(updatedCart?.item_count || 0);
        });

        // Cleanup
        return unsubscribe;
    }, [subscribe]);

    // ✅ 2. Aggiorna count cart
    useEffect(() => {
        if (cart && cart.item_count !== undefined) {
            setCountCart(cart.item_count);

        } else {
            setCountCart(0);
        }
    }, [cart]);

    useEffect(() => {
        const handleWidthResize = () => {
            const currentWidth = window.innerWidth;

            setWidth(currentWidth);

            if (currentWidth > 800) {
                setToggleNav(true);
                setToggleNavBurger(false);
                setListMenu(false);
            } else if (currentWidth <= 600) {
                setToggleNav(false);
                setListMenu(true);
            } else {
                setToggleNav(false);
                setListMenu(false);
            }
        };

        handleWidthResize();

        window.addEventListener("resize", handleWidthResize);

        return () => {
            window.removeEventListener("resize", handleWidthResize);
        };
    }, []);

    /* useEffect(() => {
        const isNegozioOnline = location.pathname.includes('negozioonline');
        if(isNegozioOnline) {
            setHiddenSubNavBar(true); 
        } else {
            setHiddenSubNavBar(false);
        } 
    }, [location.pathname]); */

    // ✅ 5. Condizioni di loading - CORRETTE
    if (themesLoading || (authLoading && !hasCheckedAuth)) {
        return <div className="header-loading">Caricamento...</div>;
    }
    
    if (error) {
        return <div className="header-error">Errore: {error}</div>;
    }

    /*  const clearSearch = () => {
        setSearchQuery('');
    };

    const handleSearch = (e) => {
        e.preventDefault();
        console.log('Searching for:', searchQuery);
        // Implementa la tua logica di ricerca
    }; */

    return (
        <nav>
            <div className={ toggleNavBurger ? "navbar-burger__header btn-burger__tranform" : "navbar-burger__header" }>
                {width <= 800 && 
                <div className="burger-logo__site">
                    <img src={LARCO} className='logo__site' alt="site's logo" />
                    <div className="burger-name__site">
                        <span>MO...STO DIVINO</span>
                        <span>ENOTRIA ABRUZZESE</span>
                        <div className='burger-bar__contact'>
                            <img src={iconPhone} 
                                alt="icon of login" 
                                className=""
                                srcSet="" 
                            />
                            <p>+39 366 401 1 401</p>
                        </div> 
                    </div>
                </div>}
                    {toggleNav && <NavLink className="nav__navlink" to="/"><p className="nav__link">Home</p></NavLink>}
                    {toggleNav && <NavLink className="nav__navlink" to="/provincedellabruzzo"><p className="nav__link">Province</p></NavLink>}
                    {toggleNav && <NavLink className="nav__navlink" to="/tipologiainabruzzo"><p className="nav__link">Tipologie</p></NavLink>}
                    {toggleNav && <NavLink className="nav__navlink" to="/vitignoinabruzzo"><p className="nav__link">Vitigni</p></NavLink>}
                    {toggleNav && <NavLink className="nav__navlink" to="/negozioonline"><p className="nav__link">Catalogo</p></NavLink>}
                    {toggleNav && isAuthenticated && <NavLink className="nav__navlink profile-navlink" to="/profile"><p className="nav__link"><ProfileIcon className="profile-icon" width={24} height={24}/> Profilo</p></NavLink>}
                <div className="burger__icon" onClick={handlerToggleNavBurger}>
                    <p className="burger__btn"><span className='burger__line'></span></p>
                </div>
            </div>

            <div className={toggleNavBurger ? "navbar-burger__folded navbar-burger__deployed" : "navbar-burger__folded"}>
            {width <= 800 && toggleNavBurger && 
                <div className='navbar-burger'>
                    <div className="burger-user">
                        {isAuthenticated ? (
                            <div className="navbar-burger-user__welcome">
                                <p>
                                    Benvenuto! { user.nome || 'Utente'}
                                </p>
                                <img src={iconLogout} alt="incon of logout" onClick={logout}/>
                            </div>
                        ) : (
                            <>
                                {/* 🔥 LOGIN CON HOVER */}
                                <div 
                                    className="user-navlink" 
                                    onMouseEnter={() => setIsLoginHovered(true)} 
                                    onMouseLeave={() => setIsLoginHovered(false)} 
                                    onClick={() => openLoginModal('login')}
                                >
                                    <img 
                                        src={isLoginHovered ? hoverLoginIcon : normaLoginIcon} 
                                        alt="Accedi"
                                        className={`hover-effect ${isLoginHovered ? 'hovered' : ''}`} 
                                    />   
                                    <p>Accedi</p>
                                </div>
                                
                                {/* 🔥 REGISTRATI CON HOVER */}
                                <div 
                                    className="user-navlink" 
                                    onMouseEnter={() => setIsAccountHovered(true)} 
                                    onMouseLeave={() => setIsAccountHovered(false)} 
                                    onClick={() => openLoginModal('regiterStep1')}
                                >
                                    <img 
                                        src={isAccountHovered ? hoverAccountIcon : normaAccountIcon} 
                                        alt="icon for home"
                                        className={`hover-effect ${isAccountHovered ? 'hovered' : ''}`} 
                                    />
                                    <p>Registrati</p> 
                                </div>
                            </>
                        )}
                    </div>
                    
                    <div className="burger-cart">
                        <div className="cart__icon" onClick={handlerCloseBurger}>
                            <NavLink to="/negozioonline/carrello">
                            <img src={Carrello} alt="Cart's Icon" title="Carrello"/>
                            </NavLink>
                        </div>
                        <div className="burger-cart__number">
                            <span>{countCart}</span>
                        </div>
                    </div>
                </div>}
                
                {toggleNavBurger &&
                <div className="burger-search">
                    <div className="burger-search__bar">
                        <form className={`burger-sbox ${isFocused ? 'focused' : ''}`} onSubmit={handleSearch}>
                            <div className="burger-sbox__icon">
                                <img src={Lente}
                                    alt=''
                                    className="search-icon" 
                                    srcSet="" 
                                />
                            </div>
                            <input
                                type="text"
                                placeholder="Cerca informazioni per parole chiave..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                onFocus={() => setIsFocused(true)}
                                onBlur={() => setIsFocused(false)}
                                aria-label="Search"
                            />
                            {searchQuery && (
                            <button type="button" className="burger-sbox__clear" onClick={clearSearch} aria-label="Clear search">
                                <FiX/>
                            </button>
                            )}    
                            <button type="submit" className="burger-sbox__submit" aria-label="Submit search">
                                Cerca
                            </button>    
                        </form>
                    </div>
                </div>}
                {toggleNavBurger && !listMenu &&
                <div className="burger-menu">
                    <NavLink className="burger__navlink" to="/"><div className="menu__link" onClick={handlerCloseBurger}><p>Home</p></div></NavLink>
                    <NavLink className="burger__navlink" to="/provincedellabruzzo"><div className="menu__link" onClick={handlerCloseBurger}><p>Province</p></div></NavLink>
                    <NavLink className="burger__navlink" to="tipologiainabruzzo"><div className="menu__link" onClick={handlerCloseBurger}><p>Tipologie</p></div></NavLink>
                    <NavLink className="burger__navlink" to="/vitignoinabruzzo"><div className="menu__link" onClick={handlerCloseBurger}><p>Vitigni</p></div></NavLink>
                    <NavLink className="burger__navlink" to="/negozioonline"><div className="menu__link" onClick={handlerCloseBurger}><p>Catalogo</p></div></NavLink>
                    {isAuthenticated && <NavLink className="burger__navlink" to="/profile"><div className="menu__link" onClick={handlerCloseBurger}><p><ProfileIcon className="profile-icon" width={20} height={20}/> Il Mio Profilo</p></div></NavLink>}
                </div>}
                {toggleNavBurger && !listMenu && <MenuManifesti themes={themes} handlerCloseBurger={handlerCloseBurger} />}
                {listMenu && <MenuOneDropDown themes={themes} articles={articles} handlerCloseBurger= {handlerCloseBurger} isAuthenticated={isAuthenticated}/>} 
                {listMenu && <MenuTwoDropDown themes={themes} articles={articles} handlerCloseBurger= {handlerCloseBurger} />}   
            </div>
        </nav>
    )
}
export default NavBar;
